import { createModuleLayout } from "@/lib/create-module-layout";
import { MODULES } from "@kubdee/shared/module-ids";
import hrModule from "@kubdee/module-hr";

export default createModuleLayout({
  moduleId: MODULES.HR,
  moduleConfig: hrModule,
});
